import $ from "jquery";
import BD_Question from "@bd-components/bd-question";

export class QuestionMultipleChoice extends BD_Question {
  constructor(questionData) {
    super();

    this.questionData = questionData;

    this.elms = {
      submit: ".js-submit",
      questionCard: ".questionCard",
      answer: ".js-answer",
    };
  }

  getAnswer(ctx) {
    return $(ctx.elms.answer.concat(":checked")).val();
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "change",
        selector: elms.answer,
        handler: this.onSelectAnswer,
        isQuestionEvent: true,
      },
    ];
  }

  onSelectAnswer() {
    $(this.elms.questionCard)
      .find(".questionCard__actions")
      .addClass("is-active");
  }
}
